import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { SsoModesFetchedAction } from '@Application/Security/Sso/Actions/ssoModesFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type SsoModesStore = {
	ssoModes: readonly LabeledValueView[] | null;
};

const initialState: SsoModesStore = {
	ssoModes: null,
};

type Actions = SsoModesFetchedAction | UserRevokedAction;

const whenSsoModesFetched = (store: SsoModesStore, action: SsoModesFetchedAction): SsoModesStore => ({
	...store,
	ssoModes: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): SsoModesStore => initialState;

export default registerStore<'ssoModesStore', Actions>(
	'ssoModesStore',
	createSliceReducer({
		SSO_MODES_FETCHED: whenSsoModesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
